import { Paths } from '../../lib/constants/path'
import { Route } from '../../lib/types/routes'
import GuideCreatePage from './guide-create'
import GuideListPage from './guide-list'
import GuideUpdatePage from './guide-update'

const guideRoutes: Route[] = [
  {
    path: Paths.GUIDE_LIST_PAGE,
    element: <GuideListPage />
  },
  {
    path: Paths.GUIDE_CREATE_PAGE,
    element: <GuideCreatePage />
  },
  {
    path: Paths.GUIDE_UPDATE_PAGE,
    element: <GuideUpdatePage />
  }
]

export default guideRoutes
